export default __webpack_public_path__ + "static/media/Asankar_banner.fe6cf992.jpg";